<template>
  <div class="conditions-box">
    <diV v-show="!isSp" class="conditions-box-shadow">
    </diV>
    <div class="conditions-box-content container">
      <div class="row condition-box-header">
        <div class="col-md-12">
          <i class="fas fa-search mr-2"/><b>検索</b>
        </div>
        <div class="col-md-12">
          <hr class="condition-box-hr">
        </div>
        <div class="col-md-12 mb-3 mt-1 simple-form">
          <input type="text" class="simple-input" v-model="selectedWord" @keypress.enter="searchByWord" placeholder="キーワードを入力">
          <span class="simple-input-button" @click="searchByWord"><i class="fas fa-search"/></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { restMethods } from '../mixins/rest_methods'
export default {
  data() {
    return {
      selectedWord: ""  
    }
  },
  methods: {
    searchByWord() {
      location.href=`/articles?query=${this.selectedWord}`;
    },
    getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },
  props: {
    isSp:{
      type: Boolean,
      default: false
    }
  },
  created(){
    const word = this.getParam("query");
    if(word) this.selectedWord = word;
  },
  computed: {
  },
  watch: {
  }
}
</script>